module.exports = __webpack_public_path__ + "static/img/6.d8b56ed.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/8/1/2/zh/6.png
// module id = zgjj
// module chunks = 0